"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _constants = require("../../constants");
var Home = function Home(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? "tyw" : _ref$brand,
    setActivePage = _ref.setActivePage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component position-relative"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-left text-md"
  }, "Let\u2019s chat"), /*#__PURE__*/_react["default"].createElement("p", null, "Got questions? Talk to our expert team today to hear more about your options."), brand !== 'qd' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-x-sm padding-y-md d8-u-radius-md border width-100% margin-top-sm d8-u-hover-shadow-md",
    style: {
      backgroundColor: 'var(--color-primary-300)',
      borderColor: 'var(--color-primary)'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "bookCall",
    buttonType: _constants.BUTTON_TYPES.NO_STYLE,
    fullWidth: true,
    onClick: function onClick() {
      return setActivePage('bookCall');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center width-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left text-component width-100%"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-font-size-base d8-u-font-weight-500 d8-u-color-primary"
  }, "Book a call")), /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "calendar",
    className: 'icon--md',
    fill: _constants.COLORS.PRIMARY
  })))), brand !== 'tyw' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-x-sm padding-y-md d8-u-radius-md border width-100% margin-top-sm d8-u-hover-shadow-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "getInTouch",
    buttonType: _constants.BUTTON_TYPES.NO_STYLE,
    fullWidth: true,
    onClick: function onClick() {
      return setActivePage('getInTouch');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center width-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left text-component width-100%"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-font-size-base d8-u-font-weight-500"
  }, brand === 'qd' ? "Address" : 'Get in touch')), /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "info",
    className: 'icon--md',
    fill: _constants.COLORS.BLACK
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-x-sm padding-y-md d8-u-radius-md border width-100% margin-top-sm d8-u-hover-shadow-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "call",
    buttonType: _constants.BUTTON_TYPES.NO_STYLE,
    fullWidth: true,
    onClick: function onClick() {
      return setActivePage('call');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center width-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left text-component width-100%"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-font-size-base d8-u-font-weight-500"
  }, "Give us a call")), /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "phone",
    className: 'icon--md',
    fill: _constants.COLORS.BLACK
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-x-sm padding-y-md d8-u-radius-md border width-100% margin-top-sm d8-u-hover-shadow-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "chat",
    buttonType: _constants.BUTTON_TYPES.NO_STYLE,
    fullWidth: true,
    onClick: function onClick() {
      return setActivePage('chat');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center width-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left text-component width-100%"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-font-size-base d8-u-font-weight-500"
  }, "Chat")), /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "headphones",
    className: 'icon--md',
    fill: _constants.COLORS.BLACK
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-x-sm padding-y-md d8-u-radius-md border width-100% margin-top-sm d8-u-hover-shadow-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "email",
    buttonType: _constants.BUTTON_TYPES.NO_STYLE,
    fullWidth: true,
    onClick: function onClick() {
      return setActivePage('email');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center width-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left text-component width-100%"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-font-size-base d8-u-font-weight-500"
  }, "Email us")), /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "email",
    className: 'icon--md',
    fill: _constants.COLORS.BLACK
  })))));
};
var _default = exports["default"] = Home;